import { useQuery } from '@tanstack/react-query';
import { fetchAudioCatalog } from './api';

/**
 * 運営提供SEカタログの一覧取得 (フェーズ5b の FE ピッカーが使う)。
 * 頻繁に変わるデータではないため generation-models と同じ 5分キャッシュ。
 */
export function useAudioCatalog(enabled: boolean = true) {
  return useQuery({
    queryKey: ['audio-catalog'],
    queryFn: fetchAudioCatalog,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
